<template>
  <section>
    <div class="max-w-6xl mx-auto px-4 sm:px-6">
      <div class="py-12 md:py-20 border-t border-gray-200 lg:border-0 lg:pt-0">
        <!-- Section header -->
        <div class="max-w-3xl mx-auto text-center pb-12">
          <h2 class="h2">お客様の声</h2>
        </div>

        <!-- Faqs -->
        <ul class="max-w-3xl mx-auto grid gap-8 grid-cols-1 xl:col-gap-16 lg:row-gap-12">
          <li>
            <h4 class="text-lg mb-2">
              首、背中に痛みが出たので「ちょうどいいタイミング！」と思い参加しました。期待通り体が軽くなり、首も回るようになりました。こんな簡単なストレッチで悩みが解決できるなら整体や針治療は必要なくなっちゃうかな？
            </h4>
            <p class="text-lg text-right text-gray-600 ">
              60代女性
            </p>
          </li>
          <li>
            <h4 class="text-lg mb-2">
              症状に合わせたストレッチを教えて頂きました！
              先生の教え方も分かりやすく、体の変化がすぐにわかり参加して良かったです。
              振り返りもあったので忘れずに継続してやります！
            </h4>
            <p class="text-lg text-right text-gray-600 ">
              50代女性
            </p>
          </li>
          <li>
            <h4 class="text-lg mb-2">
              最近、膝の動きに違和感を感じていたので相談しました。ひとつひとつ丁寧に教えてくださり、足が軽くなり膝も楽になりました。先生とお話するだけでも、癒されて元気をもらえます。ありがとうございました。
            </h4>
            <p class="text-lg text-right text-gray-600 ">
              60代女性
            </p>
          </li>
          <li>
            <h4 class="text-lg mb-2">
              とても元気なヤル気のある先生でした。体の説明も図解入りで分かりやすかったです。何より体操が手軽に出来るものばかりで、これなら続けられそう！という気になりました。
              体操のあとは体が軽くなり、効果を実感出来ました！ありがとうございました。
            </h4>
            <p class="text-lg text-right text-gray-600 ">
              50代女性
            </p>
          </li>
          <li>
            <h4 class="text-lg mb-2">
              腰痛に効くストレッチを沢山教えていただきました。それと背中のコリがほぐれ、肩懲りに即効的な、トイレでもできるストレッチを教えて頂きました！
              毎日できる短時間で簡単なストレッチは目から鱗でオススメです！
            </h4>
            <p class="text-lg text-right text-gray-600 ">
              40代女性
            </p>
          </li>
          <li>
            <h4 class="text-lg mb-2">
              講師のからだの悩みをなくしたい！という真剣な想いを感じながら、楽しく学べる講座でした。
              経験に裏打ちされた確かな知識を教えてくださるので、実践しながら自分のからだと向き合うことができました。ありがとうございました。
            </h4>
            <p class="text-lg text-right text-gray-600 ">
              50代女性
            </p>
          </li>
        </ul>
        <div class="max-w-3xl mx-auto mt-12 text-center">
          <a
            class="mx-auto flex mt-12 p-4 bg-theme-100 hover:bg-theme-200 button"
            v-scroll-to="'#cta'"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <span class="block w-full font-bold text-center text-white">お申し込みはこちら</span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CustomersVoices",
}
</script>

<style lang="scss" scoped>
.question {
  // position: relative;

  &::before {
    content: "Q.";
    color: rgba(#3ca8f6, 0.6);
    // position: absolute;
    // left: -11px;
    font-size: 2em;
    // top: -57px;
    font-weight: 700;
  }
}
</style>
